








































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
# import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'

export default {
    name: 'element_cell'

    props:
        component:
            required: true
        element_set:
            required: true
        dialog_title:
            required: true
        vpc_vpd_uid:
            required: true
        user_job_uid:
            required: true
        can_edit:
            required: true
        can_edit_all:
            required: true
        vpc_editable:
            required: true
        date:
            required: true

    watch:
        element_set: (new_one, old_one)->
            # console.log "WATCH ELEMENT SET", new_one
            @local_element_set = t.deep_copy(new_one)
            # if new_one.length == 0
            #     @local_element_set.push(@new_element)

    data: ()->
        dialog_visible: false
        element_set_table_key: ''
        picker_options: {firstDayOfWeek:1}
        max_filesize: af['vpe']['file']['max_filesize']/1024/1024
        authorized_formats: af['vpe']['file']['authorized_formats']
        total: 0
        no_change: true
        local_element_set: []
        deletions: []
        current_index: null
        new_element: {
            uid: ''
            date: ''
            value: 0
            file_url: ''
            file_name: ''
            file_data: ''
            file_tmp_uid: ''
        }

    computed:
        edit: ()->
            return @can_edit and (@can_edit_all or @vpc_editable)

    methods:
        date_formatter: t.date_formatter

        float_format: (val)->
            ret = val
            dec = String(val).split('.')
            if dec.length == 1 || dec[1].length < 2
                ret = val.toFixed(2)
            return ret

        handle_total_change: (value)->
            # console.log "CHANGE", value, @local_element_set.length
            if @local_element_set.length == 0
                @local_element_set.push(t.deep_copy(@new_element))
            @local_element_set[0].value = @total
            @save_element_set()
            return

        download_file: (element)->
            url = settings.backend_url+element.file_url
            filename = element.file_url.split('/').pop()
            t.download_file(url, filename)
            return

        upload_triggered: (index)->
            # console.log "upload_triggered", index
            @current_index = index
            @no_change = false
            return

        handle_file_remove: (file, fileList)->
            for el in @local_element_set
                if el.file_tmp_uid? and el.file_tmp_uid == file.uid
                    el.file_data = ''
                    el.file_name = ''
                    el.file_tmp_uid = ''
                    break
            fileList.splice(0,0)
            @no_change = false
            return

        handle_file_change: (file, fileList)->
            self = @
            @$confirm("Vous allez saisir un justificatif : vous devez le conserver au moins 2 mois dans le cas d'un litige ou d'un refus.", 'Confirmation', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "CONFIRM OK", self.current_index
                    is_good_ext = file.raw.type in af['vpe']['file']['mime_types']
                    is_good_size = file.size < af['vpe']['file']['max_filesize']

                    if !is_good_ext
                        n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                        fileList.pop()
                        return
                    if !is_good_size
                        n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                        fileList.pop()
                        return

                    if fileList.length > 1
                        fileList.splice(0,1)
                    reader = new FileReader()
                    reader.onload = (e)->
                        # console.log 'E', e
                        self.local_element_set[self.current_index].file_data = e.target.result
                        self.local_element_set[self.current_index].file_name = file.name
                        self.local_element_set[self.current_index].file_tmp_uid = file.uid
                    reader.readAsDataURL(file.raw)
                    # console.log "FILE", @local_element_set[@current_index]
                .catch (cancel)->
                    fileList.pop()
                    return
            return

        change_element_set: ()->
            @no_change = false
            return

        total_class: ()->
            ret = ''
            if @total > 0
                ret = 'total'
            return ret

        totalizer: (at_mounted)->
            # console.log "TOTALIZER", @local_element_set, @element_set
            if at_mounted
                @local_element_set = t.deep_copy(@element_set)
            if @local_element_set.length > 0
                # console.log "totalizer", @local_element_set
                @total = @local_element_set
                    .map (x)-> return x.value
                    .reduce (acc, value)-> return acc + value
                # element_set['total'] = @float_format(element_set['total'])
            else
                @total = 0

        delete_file: (index)->
            # console.log "DELETE FILE", index
            @local_element_set[index].file_url = ""
            @no_change = false
            return

        edit_element_set: ()->
            # console.log "EDIT ELEMENT SET", @local_element_set, @element_set
            # @local_element_set = t.deep_copy(@element_set)
            # if @local_element_set.length == 0
            #     @local_element_set.push(t.deep_copy(@new_element))
            @dialog_visible = true
            return

        # reset_new_element: ()->
        #     console.log "RESET NEW ELEMENT"
        #     @new_element = {
        #         uid: ''
        #         date: ''
        #         value: 0
        #         file_name: ''
        #         file_data: ''
        #     }
        #     return

        cancel_element_set: ()->
            # console.log "CANCEL ELEMENT SET"
            @local_element_set = @local_element_set.filter (x)->
                if x.uid != ''
                    return x
            # @reset_new_element()
            @current_index = null
            @deletions = []
            @dialog_visible = false
            @no_change = true
            return

        add_new_element: ()->
            # console.log "ADD NEW ELEMENT"
            @local_element_set.push(t.deep_copy(@new_element))
            return

        delete_element: (index, uid)->
            # console.log "DELETE ELEMENT", index, uid, 'element_upload'+index
            # console.log "DELETE ELEMENT", @$refs
            # ## There is a bug, when we create 2 lines in element cell tab with file in each, when we delete the first of them
            # ## the file name is modified in frontend, it disapsears or it takes delete one name...
            # ## The bug is not resolved...
            # if @$refs['element_upload'+index]?
                # @$refs['element_upload'+index].clearFiles()
            @local_element_set.splice(index, 1)
            # @element_set_table_key = +new Date()
            if uid != ''
                @deletions.push(uid)
            @no_change = false
            # console.log "DELETE ELEMENT END", @local_element_set.length
            return

        save_element_set: ()->
            # console.log "SAVE ELEMENT SET", @local_element_set
            for item in @local_element_set
                if item.value == 0
                    n.error('Erreur', 'Une valeur est requise')
                    return
            self = @
            m.run('save_element_set', [@local_element_set, @deletions, @vpc_vpd_uid, @user_job_uid, @component])
            .then (resp)->
                # console.log "ELEMENT SET MUTATION RESPONSE", resp.body.data.vp_element_set_mutation.message
                if resp.body.data.vp_element_set_mutation.ok
                    uid_set = JSON.parse(resp.body.data.vp_element_set_mutation.message.replace(/'/g,"\""))
                    for index, el of self.local_element_set
                        if el.uid == ''
                            el.uid = uid_set[index]
                    self.totalizer(false)
                    self.current_index = null
                    self.deletions = []
                    self.dialog_visible = false
                    self.no_change = true
                else
                    # self.$emit('error-element-set')
                    n.error("vpe_table: save_element_set()", resp.body.data.vp_element_set_mutation.message)
            .catch (resp)->
                n.catch_error(resp, "vpe_table: save_element_set()")
            return
            
    beforeMount: ()->
        # console.log "beforeMount element_cell", @element_set
        @totalizer(true)
}
